import { MessageSquareText, ClipboardCheck, Hammer } from "lucide-react";
import ChapterHeading from "./ChapterHeading";
import Reveal from "./Reveal";

const STEPS = [
  {
    num: "01",
    icon: MessageSquareText,
    title: "Tell us what you need",
    copy: "Call, message or upload photos of the area through the quote form — whatever's easiest.",
  },
  {
    num: "02",
    icon: ClipboardCheck,
    title: "We assess the space",
    copy: "If needed, we visit to check wall types, placement, and any pipework or power risks — a call-out assessment fee applies, always confirmed before we come out.",
  },
  {
    num: "03",
    icon: Hammer,
    title: "Professionally installed",
    copy: "The right rails or ramps, installed carefully and properly — ready to use straight away.",
  },
];

export default function HowItWorks() {
  return (
    <section data-testid="how-it-works-section" className="bg-sand">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-24 lg:px-8 lg:py-28">
        <ChapterHeading
          num="02"
          eyebrow="How it works"
          title="From first call to fitted — simple."
          testid="how-it-works-heading"
        />
        <div className="mt-14 grid gap-5 md:grid-cols-3">
          {STEPS.map((step, i) => (
            <Reveal key={step.num} delay={i * 0.08}>
              <div
                data-testid={`how-it-works-step-${i}`}
                className="group relative h-full overflow-hidden rounded-3xl border border-line bg-white p-8 transition-colors duration-300 hover:border-sage"
              >
                <span
                  className="pointer-events-none absolute -right-1 -top-2 font-display text-7xl font-extrabold text-sand transition-colors duration-300 group-hover:text-sage-light"
                  aria-hidden="true"
                >
                  {step.num}
                </span>
                <step.icon className="relative h-7 w-7 text-sage-dark" aria-hidden="true" />
                <h3 className="relative mt-5 font-display text-xl font-bold text-charcoal">{step.title}</h3>
                <p className="relative mt-3 text-sm leading-relaxed text-ink/70">{step.copy}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
